import * as React from 'react';
import {
    Popup,
} from 'react-map-gl';
import {toTitleCase} from "../../utils/utils";
import parse from 'html-react-parser';


// TODOD: factor out this constant and import it
const HIDE_UNAVAILABLE_DATA_IN_POPUPS = true

function FillLayerStackPopup({popupData, popupDataSetter}) {
    console.log('popupData')
    console.log(popupData)

    return (
        <Popup
            longitude={popupData.longitude}
            latitude={popupData.latitude}
            anchor="top"
            style={{paddingBottom: '35px'}}
            onClose={() => popupDataSetter(null)}
            closeOnClick={false}
            maxWidth={'auto'}
        >
            <strong style={{'fontSize': '1rem'}}>
                {/*{toTitleCase(popupData.title)}*/}
                {popupData.title}
            </strong>
            <hr className={'mb-1 mt-1'}/>
            <div>
                Longitude: {popupData.longitude}
            </div>
            <div>
                Latitude: {popupData.latitude}
            </div>
            <hr className={'mb-1 mt-1'}/>
            {Object.keys(popupData.attrDict).length > 0 ?
                Object.entries(popupData.properties).map(
                    ([k, v]) =>
                        (Object.keys(popupData.attrDict).includes(k))
                        && !(v == 'Data Unavailable' && HIDE_UNAVAILABLE_DATA_IN_POPUPS)
                        &&
                        <div key={k}>
                            <strong>{parse(popupData.attrDict[k])}: </strong>
                            {v}
                        </div>
                ) :
                Object.entries(popupData.properties).map(
                    ([k, v]) =>
                        <div key={k}>
                            <strong>{k}: </strong>
                            {v}
                        </div>
                )
            }
        </Popup>)
}

export default React.memo(FillLayerStackPopup);
